<div class="d-flex flex-column align-items-center justify-content-center border-radius-38 main-container px-20  py-52 ">
  <mat-icon class="material-symbols-outlined color-azureblue mb-27 fs-100" fontIcon="error">
  </mat-icon>
  <p class="fw-700 ff-Sarabun fs-32 line-height-32 color-white mb-33">{{ 'SESSION.DELETED' | translate }} </p>
  <p class="fw-400 ff-Sarabun fs-18 line-height-22 color-white mb-33">{{ 'SESSION.DELETED1' | translate }} </p>
  <div (click)="close()" class="w-p-100 d-flex gap-8 align-content-center  justify-content-center line text-center py-16 close-btn  border-radius-30 bg-azureblue color-white  cursor-pointer border-none">
    <span class="fs-18 line-height-22 fw-400 ff-Inter">{{ 'SESSION.BACK_TO_LOGIN' | translate }}</span>   <mat-icon class="material-symbols-outlined color-white  fs-24" fontIcon="arrow_forward">
  </mat-icon>
  </div>
</div>
